import React from 'react';
import {
  getTranscriptStatusLabel,
  normalizeTranscriptStatus,
  TRANSCRIPT_STATUS,
} from '../../utils/transcriptCertification';

const TranscriptStatusBadge = ({ transcription, className = '' }) => {
  const status = normalizeTranscriptStatus(transcription);
  const label = getTranscriptStatusLabel(status);
  const badgeClass =
    status === TRANSCRIPT_STATUS.CERTIFIED
      ? 'transcript-status-certified'
      : status === TRANSCRIPT_STATUS.SUPERSEDED
        ? 'transcript-status-superseded'
        : 'transcript-status-draft';

  const prefix =
    status === TRANSCRIPT_STATUS.CERTIFIED ? '✓ ' : status === TRANSCRIPT_STATUS.SUPERSEDED ? '↩ ' : '◷ ';

  return (
    <span className={`${badgeClass} ${className}`.trim()}>
      {prefix}
      {label}
    </span>
  );
};

export default TranscriptStatusBadge;
